 import {Facility} from './ApplicationModel';
import { ChangeType, Location } from './ApplicationDetail';

 export class ApplicantType {
    applicationTypeCode: string;
    name: string;
    id: number;
 }

 export class FacilityType {
    isExpanded: boolean;
    productTypes: ProductType[];
    facilityTypeCode: string;
    name: string;
    id: number;
 }
 export class ApplicationCategory {
    isActive: boolean;
    applicationCategoryCode: string;
    name: string;
    id: number;
    facilityTypes: FacilityType[];
    facilityCategories: FacilityCategory[];
    regions: RegionType[];
    isExpanded: boolean;
 }

 export class FacilityCategory {
    isActive: boolean;
    facilityCategoryCode: string;
    name: string;
    id: number;
    isExpanded: boolean;
    facilityTypes: FacilityType[];
    facilities: Facility[];
 }
 export class FeeInfo {
   'facilityTypeID': number;
   'productTypeID': number;
   'applicationCategoryID': number;
   'facilityCategoryID': number;
   'changeTypeRefID': number;
   'withinRegion': boolean;
   'fee': number;
   'id': number;
   'createdDate': string;
   'isActive': boolean;
   'modifiedDate': string;
   'rowGuid': string;
 }

 export class OwnershipType {
    organizationTypeCode: string;
    name: string;
    id: number;
 }

 export class MLevel {
    mLevelTypeCode: string;
    name: string;
    id: number;
    isExpanded: boolean;
    manufacturingRiskLevels: MRLevel[];
 }

 export class MRLevel {
    mrLevelTypeCode: string;
    name: string;
    id: number;
 }

 export class EducationLevel {
    educationLevelCode: string;
    name: string;
    id: number;
    rank: number;
   isSelected: Boolean;
   qualificationDisabled: Boolean;
 }


 export class ProfessionalType {
    professionalTypeCode: string;
    name: string;
    id: number;
    isExpanded: boolean;
    professionalFields: ProfessionalField[];
 }

 export class ProductType {
   isExpanded: boolean;
   name: string;
   id: number;
   specificProducts: SpecificProduct[];
   changeTypes: ChangeType[];
   manufacturingLevels: MLevel[];
}
 export class ProfessionalField {
   professionalFieldCode: string;
   name: string;
   dataType: string;
   id: number;
   isActive: true;
   createdDate: string;
   modifiedDate: string;
   rowGuid: string;
   isSelected: boolean;
}


export class QualificationType {
   qualificationCode: string;
   name: string;
   id: number;
   isSelected: Boolean;
}

export class RegionType {
   regionCode: string;
   name: string;
   id: number;
}

export class WoredaType {
   woredaCode: string;
   name: string;
   id: number;
   zoneID: number;
   subCityID: number;
}

export class SubCityType {
   name: string;
   id: number;
   zoneID: number;
}

export class ZoneType {
   zoneCode: string;
   name: string;
   id: number;
   regionID: number;
   isCity: boolean;
}

export class City {
   cityCode: string;
   name: string;
   id: number;
}

export class SpecificProduct {
   specificProductCode: string;
   name: string;
   id: number;
   title: string;
   facilityTypeID: number;
   productTypeID: number;
}

export class SpecificProductItem {
   spItemCode: string;
   name: string;
   id: number;
   specificProductID: number;
   brandName: string;
}

export class Warehouse {
  name: string;
  locationId: number;
  location: Location;
  id: number;
  isActive: Boolean;
}

export class AssignAppToUser {
   applicationID: number;
   assignees: Assignee[];
   dueDate: string;

   constructor(appID: number, assignees: Assignee[], date: string) {
      this.applicationID = appID;
      this.assignees = assignees;
      this.dueDate = date;
   }
}

export class PaymentReciptDoc {
   applicationID: number;
   fileID: number;
   recieptNumber: string;

   inspectionID: number; //inspection module payment doc
   multiIDs?: number[]; //for multi payment mode
   isFinalPaymentGMP?: boolean; //for GMP final payment
}


export class Assignee {
   primary = false;
   userID: number;

   constructor(id: number, primary: boolean) {
      this.userID = id;
      this.primary = primary;
   }
}

export class Department {
   id: number;
   name: string;
   constructor(id: number, name: string) {
      this.id = id;
      this.name = name;
   }
}

export class ApplicationStatus {
   id: number;
   name: string;
   applicationStatusCode: string;
}


export class NonPrimaryAssignee {
   public applicationID: number;
   public names: string;
 }

export class ProfessionalControls {
   name: string;
   qualification: string;
   educationLevel: string;
   experience: string;
   phoneNo: string;
   email: string;
   licenseNumber ?: string;

   constructor(name: string, qualification: string, educationLevel: string, experience: string, email: string,
               phoneNo: string,  license?: string ) {
      this.name = name;
      this.qualification = qualification;
      this.educationLevel = educationLevel;
      this.experience = experience;
      this.phoneNo = phoneNo;
      this.email = email;
      if (license) {
        this.licenseNumber = license;
      }
   }
}

export class DiplomaSelection {
   educationLevelInput: string;
   diplomaSelected: boolean;
   constructor(input, selected) {
      this.educationLevelInput = input;
      this.diplomaSelected = selected;
   }
}

export class SystemSetting {
  name: string;
  value: string;
  systemSettingCode: string;
  dataType: string;
  dateValue: Date;
  description: string;
  valueObj: any;
  id: number;
  createdDate: string;
  isActive: boolean;
  modifiedDate: string;
  rowGuid: string;
}

export class BranchOffice {
  regionID: number;
  region: RegionType;
  zoneID: number;
  zone: ZoneType;
  woredaID: number;
  woreda: WoredaType;
  city: City;
  name: string;
  label: string;
  id: number;
  createdDate: string;
  isActive: boolean;
  modifiedDate: string;
  rowGuid: string;
}

export class FoodManufDoc {
   public mLevelID: number;
   public mRLevelID: number;
 }

export class changeTypeRefData {
   changeTypeRefIDs : Array<number>;
   facilityTypeID : number;
   productTypeID: number;
   applicationCategoryID : number;
   constructor(changeTypeRefIDs, facilityTypeID, productTypeID, applicationCategoryID){
      this.changeTypeRefIDs = changeTypeRefIDs;
      this.facilityTypeID = facilityTypeID;
      this.productTypeID = productTypeID;
      this.applicationCategoryID = applicationCategoryID;
   }

}

export class FIRItem {
   name: string;
   subItems: FIRSubItem[] = [];
   selected: boolean;
}

export class FIRSubItem{
   name: string;
   selected: boolean;
}

export class Menu {
   id: number;
   parentMenuID : number;
   name : string;
   url : string;
   icon : string;
   priority : number;
   menuCode : string;
   parentMenu : Menu;
   checked: boolean;
   isExpanded: boolean;
   childMenus : Menu[];
}

export class MenuRole{
   menuID: number;
   roleID: number;
   menu: Menu;
   id: number;
}

export class ExpiryDateExtension{
   applicationID: number;
   facilityID: number;
   comment: string;
   date: Date;
}

export class TinClaim{
   tin: string;
   organizationTypeID: number;
   ownerName: string;
   ownerPhone: string;
   // for private organization facilityName has to be provided by the applicant
   facilityName: string;
}

export class Country {
   id: number;
   name: string;
   countryCode: string;
}

export class ApiResponse {
   isSuccess: boolean;
   message: string;
   data: any;
   status: number;
}
